<div class="container">
  <div class="checkout-footer mat-display-2 p-5">
    <fa-icon icon="lock"></fa-icon>
    <ng-container i18n="@@Note.AuthFlow.TransactionSafe">
      100% Secure. Rest assured, your transaction is safe.
    </ng-container>
  </div>
</div>
